const removeKeysWithUndefined = (obj) => Object.keys(obj)
    .filter((key) => obj[key] !== undefined)
    .reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
}, {});
export default removeKeysWithUndefined;
//# sourceMappingURL=removeKeysWithUndefined.js.map